import React, { Component } from 'react'
import styled from 'styled-components'
import HelpfulHint from './HelpfulHint'
import NotesUtil from '../../helpers/NotesUtil'

const Container = styled.div`
  margin: 8px 0;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`
const Title = styled.h3`
  height: 22px;
  width: 119px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  display: flex;
`
const SubTitle = styled.div`
  height: 19px;
  color: #6A6A6A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  display: flex;
`
const AccessText = styled.div`
display: inline-flex;
color: #808284;
margin-top: 12px;
font-size: 14px;
`;
const LinkButton = styled.div`
  padding: 0 0 10px 0;
  margin-left: 15px;
  height: 19px;
  width: 127px;
  color: #48A3D1;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
  text-align: end;
`;

const Line = styled.div`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #DBDBDC;
  margin-bottom: 10px;
`
const Hints = styled.div`
  padding: 8px 0;
  transition: background-color 0.2s ease;
  background-color: 'white'
`

export default class HelpfulHints extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hints: this.getCategories(props.loan.helpfulHints),
      hideAll: false,
    }
  }

  onHideShowAll = () => {
    const {hideAll} = this.state
    this.setState({
      ...this.state,
      hideAll: !hideAll,
    })
  }

  getTitle = name => {
    return name.split('_').map(w =>  w.substring(0,1).toUpperCase()+ w.substring(1)).join(' ')
  }

  groupHintsByCategory = helpfulHints => {
    return helpfulHints.reduce((acc, obj) => {
      const key = obj.category
      if (!acc[key]) {
        acc[key] = []
      }
      acc[key].push(obj)
      return acc
    }, [])
  }

  getCategories = helpfulHints => {
    const hints = this.groupHintsByCategory(helpfulHints)
    const categories = Object.keys(hints).map(key => {
      let category = {}
      category.title = this.getTitle(key);
      category.helpfulHints = hints[key]
      return category
    })
    return categories
  }

  render() {
    const { hints, hideAll } = this.state
    const { isBankUser } = this.props
    const title = 'Helpful Hints'
    const subTitle = 'Review these hints as you analyze this customer.'
    return (
      <Container>
        <Header>
          <Title>{title}</Title>
          {!isBankUser && (
            <AccessText>
              {NotesUtil.getAccessText(isBankUser)}
            </AccessText>
          )}
        </Header>
        <Line/>
        <Header>
          <SubTitle>{subTitle}</SubTitle>
          {!isBankUser && (
            <LinkButton
              id='linkButton'
              onClick={this.onHideShowAll}>
                {hideAll ? 'Show' : 'Hide'} all
            </LinkButton>
          )}
        </Header>
        {!hideAll && (
          <Hints>
            {(hints.map((hint, index) => (
              <HelpfulHint
                key={index}
                hint={hint}
              />
            ))
            )}
          </Hints>
        )}
      </Container>
    )
  }
}
